module.exports = __webpack_public_path__ + "static/media/cedricdiggory.fab96e78.jpeg";